import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "@i18n";
import { PURCHASE_METHOD_AMWAL, PURCHASE_METHOD_TABBY, PURCHASE_METHOD_TAMRA, useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { trackEvents } from "@/common/events/events";
import RadioCardNew from "@/pages/checkout/pre-checkout/RadioCard/RadioCardNew";
import useBoolean from "@hooks/useBoolean";
import TabbyModal from "@/pages/checkout/pre-checkout/PurchaseMethods/TabbyModal";
import AmwalModal from "@/pages/checkout/pre-checkout/PurchaseMethods/AmwalModal";
import TamaraModal from "@/pages/checkout/pre-checkout/PurchaseMethods/TamaraModal";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { api__tabbyPreScoring } from "@/apis/tabby/tabby";
import Markdown from "markdown-to-jsx";
import { twMerge } from "tailwind-merge";
var BuyNowPayLater = function BuyNowPayLater() {
  var _checkoutOrder$bnpl_o, _checkoutOrder$sale_p, _checkoutOrder$sale_p2, _checkoutOrder$sale_p3;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    purchaseMethod = _useCheckoutOrder$sta.purchaseMethod;
  var action__setPurchaseMethod = useCheckoutOrder().actions.action__setPurchaseMethod;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var tabbyModal = useBoolean();
  var amwalModal = useBoolean();
  var tamaraModal = useBoolean();
  var _useState = useState(null),
    tabbyEligible = _useState[0],
    setTabbyEligible = _useState[1];
  var _useState2 = useState(null),
    tabbyRejectionMessage = _useState2[0],
    setTabbyRejectionMessage = _useState2[1];
  var bnplOptions = (_checkoutOrder$bnpl_o = checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.bnpl_options) !== null && _checkoutOrder$bnpl_o !== void 0 ? _checkoutOrder$bnpl_o : [];
  var hasTabbyOption = bnplOptions.some(function (o) {
    return o.type === "tabby";
  });
  useEffect(function () {
    if (!hasTabbyOption || !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_id)) return;
    if (!isLoggedIn) {
      setTabbyEligible(true);
      return;
    }
    api__tabbyPreScoring({
      post_id: checkoutOrder.post_id,
      phone_number: user.phone_number
    }).then(function (res) {
      if (res.data.rejection_reason) {
        setTabbyEligible(false);
        setTabbyRejectionMessage(res.data.message);
      } else {
        setTabbyEligible(true);
      }
    })["catch"](function () {
      setTabbyEligible(true);
    });
  }, [hasTabbyOption, isLoggedIn, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id]);
  var configMap = useMemo(function () {
    return {
      tamara: {
        purchaseMethod: PURCHASE_METHOD_TAMRA,
        trackingEvent: "tamara_widget_click",
        ctaTextKey: "pre-checkout/how_to_tamara",
        modal: tamaraModal
      },
      tabby: {
        purchaseMethod: PURCHASE_METHOD_TABBY,
        trackingEvent: "tabby_widget_click",
        ctaTextKey: "pre-checkout/how_to_tabby",
        modal: tabbyModal
      },
      amwal: {
        purchaseMethod: PURCHASE_METHOD_AMWAL,
        trackingEvent: "amwal_widget_click",
        ctaTextKey: "pre-checkout/how_to_amwal",
        modal: amwalModal
      }
    };
  }, [tamaraModal, tabbyModal, amwalModal]);

  // Sort: move ineligible tabby to the bottom
  var sortedOptions = useMemo(function () {
    var options = _toConsumableArray(bnplOptions);
    if (tabbyEligible === false) {
      options.sort(function (a, b) {
        if (a.type === "tabby") return 1;
        if (b.type === "tabby") return -1;
        return 0;
      });
    }
    return options;
  }, [bnplOptions, tabbyEligible]);
  var isTabbyDisabled = function isTabbyDisabled(optionType) {
    return optionType === "tabby" && tabbyEligible === false;
  };
  var getTabbyDisabledNote = function getTabbyDisabledNote() {
    return tabbyRejectionMessage !== null && tabbyRejectionMessage !== void 0 ? tabbyRejectionMessage : null;
  };
  if (bnplOptions.length === 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mx-[-16px] bg-white px-4 py-4 md:mx-[-42px] md:px-[42px] md:pb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-[#00143C] font-medium md:text-xl"
  }, tShort("pre-checkout/buy_now_pay_later_title", {
    ns: "web_pre_checkout"
  })), sortedOptions.map(function (option) {
    var _option$bank_icons;
    var config = configMap[option.type];
    if (!config) return null;
    var isTabbyLoading = option.type === "tabby" && isLoggedIn && tabbyEligible === null;
    if (isTabbyLoading) {
      return /*#__PURE__*/React.createElement("div", {
        key: option.type,
        className: "rounded-lg p-5 bg-white border border-solid border-gray-echo animate-pulse"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-6 h-6 rounded-full bg-gray-200 flex-shrink-0"
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-2 w-full"
      }, /*#__PURE__*/React.createElement("div", {
        className: "h-5 w-20 rounded bg-gray-200"
      }), /*#__PURE__*/React.createElement("div", {
        className: "h-3 w-3/4 rounded bg-gray-200"
      }), /*#__PURE__*/React.createElement("div", {
        className: "h-3 w-3/4 rounded bg-gray-200"
      }), /*#__PURE__*/React.createElement("div", {
        className: "h-3 w-3/4 rounded bg-gray-200"
      }))));
    }
    var disabled = isTabbyDisabled(option.type);
    return /*#__PURE__*/React.createElement(RadioCardNew, {
      id: option.type + "_purchase_method",
      key: option.type,
      name: "purchase_method",
      value: config.purchaseMethod,
      checked: purchaseMethod === config.purchaseMethod,
      onChange: function onChange(e) {
        action__setPurchaseMethod(e.target.value);
      },
      disabled: disabled,
      disabledNote: disabled ? getTabbyDisabledNote() : undefined,
      title: /*#__PURE__*/React.createElement("div", {
        className: "bg-[#F9F9FD] flex items-center p-1 rounded border border-solid border-[#e9e9e9] gap-3 w-full"
      }, /*#__PURE__*/React.createElement("img", {
        src: option.image_url,
        alt: option.type,
        width: (option === null || option === void 0 ? void 0 : option.type) === 'amwal' ? '30' : '65',
        height: "25",
        className: "object-contain"
      }), /*#__PURE__*/React.createElement(Markdown, {
        className: "text-black-primary text-xs font-medium [&>strong]:font-black [&>strong]:text-black-primary"
      }, option === null || option === void 0 ? void 0 : option.title)),
      onClickTitle: function onClickTitle() {
        trackEvents(config.trackingEvent, {
          referral_location: "pre_checkout"
        });
      },
      description: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: twMerge("flex flex-wrap md:flex-nowrap justify-between items-center gap-y-2 gap-x-3 w-full")
      }, /*#__PURE__*/React.createElement("div", {
        className: twMerge("w-full md:w-auto md:max-w-[370px] md:flex md:flex-col")
      }, /*#__PURE__*/React.createElement(Markdown, {
        className: "[&>strong]:font-black [&>strong]:text-black-primary"
      }, option.description), /*#__PURE__*/React.createElement("span", {
        className: "hidden md:inline-block text-primary-new text-xs font-semibold underline ms-1 mt-1"
      }, /*#__PURE__*/React.createElement("span", {
        className: "!text-primary-new md:font-bold"
      }, tShort(config.ctaTextKey, {
        ns: "web_pre_checkout"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "md:hidden"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-primary-new text-xs font-semibold underline ms-1"
      }, /*#__PURE__*/React.createElement("span", {
        className: "!text-primary-new"
      }, tShort(config.ctaTextKey, {
        ns: "web_pre_checkout"
      })))), (option === null || option === void 0 ? void 0 : option.bank_icons) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "flex shrink-0 gap-2 items-center"
      }, option === null || option === void 0 ? void 0 : (_option$bank_icons = option.bank_icons) === null || _option$bank_icons === void 0 ? void 0 : _option$bank_icons.map(function (bank_icon, index) {
        return /*#__PURE__*/React.createElement("img", {
          key: index,
          src: bank_icon === null || bank_icon === void 0 ? void 0 : bank_icon.path,
          alt: "",
          height: 33,
          width: 50,
          className: "w-[50px] h-[33px] object-contain md:h-[45px] md:w-[50px]"
        });
      }))))),
      onClickCta: function onClickCta(e) {
        e.preventDefault();
        e.stopPropagation();
        config.modal.setTrue();
        trackEvents(config.trackingEvent, {
          referral_location: "pre_checkout"
        });
      },
      showStoryModal: false
    });
  }))), /*#__PURE__*/React.createElement(TabbyModal, {
    isOpen: tabbyModal.value,
    onClose: tabbyModal.setFalse,
    price: Number(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$sale_p = checkoutOrder.sale_price) === null || _checkoutOrder$sale_p === void 0 ? void 0 : _checkoutOrder$sale_p.replace(",", ""))
  }), /*#__PURE__*/React.createElement(AmwalModal, {
    isOpen: amwalModal.value,
    onClose: amwalModal.setFalse,
    price: Number(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$sale_p2 = checkoutOrder.sale_price) === null || _checkoutOrder$sale_p2 === void 0 ? void 0 : _checkoutOrder$sale_p2.replace(",", ""))
  }), /*#__PURE__*/React.createElement(TamaraModal, {
    isOpen: tamaraModal.value,
    onClose: tamaraModal.setFalse,
    amount: Number(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$sale_p3 = checkoutOrder.sale_price) === null || _checkoutOrder$sale_p3 === void 0 ? void 0 : _checkoutOrder$sale_p3.replace(",", ""))
  }));
};
export default BuyNowPayLater;